import React, { ReactNode } from 'react';
import { RenderBounds, RenderBox, RenderInner, RenderSvg } from '../../../app/canvas/visualization/RenderHelpers';
import { Sketch } from './Sketch';
import { SketchLayout } from './SketchLayout';

export const SketchVisual = ({ object, children }: { object: Sketch, children: ReactNode }) => {
    // usePose is used in ShapeVisual, including it here for consistency in case selection/editing visuals are needed later.
    // const { beingEdited } = usePose(object);

    return (
        <>
            <RenderBounds object={object}>
                <RenderInner object={object}>
                    <RenderBox width={object.width} height={object.height} />
                    {/* <RenderGraffiti object={object} /> */}
                    <Render layout={object.layout} />
                </RenderInner>
            </RenderBounds>
            {children}
        </>
    );
};

const Render = React.memo(({ layout }: { layout: SketchLayout }) => {

    const { base, paths, padding, spines } = layout;
    const paddedBase = base.inflate(padding);

    return <RenderSvg area={paddedBase}>
        <g transform={`translate(${-paddedBase.left} ${-paddedBase.top})`}>
            {paths.map(x =>
                <g key={x.id}>
                    {x.style === 'fill' && <path key={x.id} d={x.path.toString()} fill={x.color} />}
                    {x.style === 'stroke' && <path key={x.id} d={x.path.toString()} fill="none" strokeLinecap="round" strokeLinejoin="round" stroke={x.color} strokeWidth={x.size} />}
                </g>
            )}
            {/* {spines.map(x =>
                <path key={x.id} d={Path.from(x.path).toString(true)} fill="none" strokeWidth={2} stroke="red" />
            )} */}
            {/* {paths.map(x =>
                <path key={x.id} d={x.hit.toString()} fill="none" strokeWidth={2} stroke="red" />
            )} */}
        </g>
    </RenderSvg>;
});
